import React from 'react';
import {PropTypes} from 'prop-types';
import {PropTypesEx} from '../../shared/proptypes.extensions';
import {EmailSubscriptionsComponent} from '../../components/EmailSubscriptions';
import {MakeApiCall, WriteConsoleErrors, AssignProperties} from '../../shared/utils';
import {LoadingIndicatorComponent} from '../../shared/loadingIndicatorComponent';
import {ErrorsBlockComponent} from '../../shared/errorsBlockComponent';

export class NotificationSettingsComponent extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);
        this.strings = {...this.constructor.defaultProps.strings};
        AssignProperties(this.strings, props.strings);

        this.state = {
            isLoaded: false,
            isLoading: false,
            errors: null,
            email: '',
            accountEmail: '',
            emailSubscriptions: [],
            mailTypes: null
        }

        this.doLoad = this.doLoad.bind(this);
        this.doSave = this.doSave.bind(this);
    }

    componentDidMount() {
        const self = this;
        self._isMounted = true;
        if (!self.state.isLoaded) {
            self.doLoad();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }

        const {settingsToken, loadSettingsUrl} = self.props;

        const data = {SettingsToken: settingsToken};

        new Promise(resolve => {
            self.setState({isLoading: true, errors: null}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: loadSettingsUrl,
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted
                );
            }
        })
        .then(responseData => {
            if (self._isMounted) {
                self.setState({
                    isLoading: false,
                    isLoaded: true,
                    email: responseData.Email,
                    accountEmail: responseData.AccountEmail,
                    emailSubscriptions: responseData.EmailSubscriptions,
                    mailTypes: responseData.MailTypes,
                })
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted) {
                self.setState({isLoading: false, errors: errors});
            }
        });
    }

    doSave(mailTypeId, isUnsubscribed) {
        const self = this;

        if (self._isMounted) {
            const {settingsToken, verificationToken, saveSettingsUrl} = self.props;

            const data = {SettingsToken: settingsToken, MailTypeId: mailTypeId, IsUnsubscribed: isUnsubscribed};

            const result = MakeApiCall(
                $.post(
                    {
                        url: saveSettingsUrl,
                        headers: {RequestVerificationToken: verificationToken},
                        data: data,
                        dataType: 'json',
                        cache: false
                    }
                ),
                false,
                () => !self._isMounted
            )
            .then(responseData => {
                if (self._isMounted) {
                    self.setState({
                        isLoaded: true,
                        email: responseData.Email,
                        accountEmail: responseData.AccountEmail,
                        emailSubscriptions: responseData.EmailSubscriptions
                    })
                }
            })
            .catch(errors => {
                WriteConsoleErrors(errors, false, false);
            });

            return result;
        }
        else {
            return Promise.resolve(null);
        }
    }

    render() {
        const self = this;
        const {isLoaded, isLoading, errors, email, accountEmail, emailSubscriptions, mailTypes} = self.state;
        const {showAccountInfo, saveSettingsUrl, id} = self.props;

        if (!isLoaded) {
            return (
                <div>
                    <LoadingIndicatorComponent visible={isLoading} />
                    <ErrorsBlockComponent errors={errors} unstyled />
                </div>
            )
        }

        const strings = self.strings;

        return (
            <div id={id}>
                <div className="data-group">
                    <label>{strings.L_Email}</label>
                    <span>{email}</span>
                </div>
                {showAccountInfo &&
                    <div className="data-group">
                        <label>{strings.L_AccountEmail}</label>
                        <span>{accountEmail}</span>
                    </div>
                }
                <EmailSubscriptionsComponent 
                    id={id + '.EmailSubscriptions'}
                    disabled={false}
                    readOnly={!Boolean(saveSettingsUrl)}
                    subscriptions={emailSubscriptions}
                    usedMailTypes={mailTypes}
                    doSaveMailSubscription={self.doSave}
                    strings={strings}
                />
            </div>
        )
    }
}
NotificationSettingsComponent.propTypes = {
    strings: PropTypes.object,
    settingsToken: PropTypes.string.isRequired,
    loadSettingsUrl: PropTypes.string.isRequired,
    saveSettingsUrl: PropTypes.string,
    showAccountInfo: PropTypes.bool,
    verificationToken: PropTypes.string.isRequired,
    id: PropTypesEx.elementId.isRequired,
}
NotificationSettingsComponent.defaultProps = {
    strings: {
        BTN_EnableAll: 'Enable all',
        BTN_DisableAll: 'Disable all',
        L_Email: 'Email recipient',
        L_AccountEmail: 'SqlBak.com account'
    },
    showAccountInfo: true,
}